import { render, staticRenderFns } from "./mod21.vue?vue&type=template&id=1f490c8e&scoped=true&"
import script from "./mod21.vue?vue&type=script&lang=js&"
export * from "./mod21.vue?vue&type=script&lang=js&"
import style0 from "./mod21.vue?vue&type=style&index=0&id=1f490c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f490c8e",
  null
  
)

export default component.exports